import React, { useState } from 'react';
import './StoryGenerator.css';

const StoryGenerator = () => {
  const [story, setStory] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateRandomStory = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch('https://scaremetosleepapi.azurewebsites.net/api/stories/random');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.text();
      setStory(data);
    } catch (err) {
      setError('Failed to generate story. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="story-generator">
      <h1>Scare Me To Sleep</h1>
      <div className="controls">
        <button 
          onClick={generateRandomStory}
          disabled={isLoading}
        >
          {isLoading ? 'Generating...' : 'Random Story'}
        </button>
      </div>
      {error && <div className="error">{error}</div>}
      <div className="story-content">
        {story}
      </div>
    </div>
  );
};

export default StoryGenerator;
